import request from '@/utils/ajax';

export function addMsgReply(data){
  return request({
    url: `/wx/manage/msgReplyRule/save`,
    method: 'post',
    data
  });
}


export function updateMsgReply(data){
  return request({
    url: `/wx/manage/msgReplyRule/update`,
    method: 'post',
    data: data
  });
}

export function deleteMsgReply(data){
  return request({
    url: `/wx/manage/msgReplyRule/delete`,
    method: 'post',
    data: data
  });
}
